"use strict";

import { portfolioConstants } from "../_constants";

export const accountSummaryRequest = (payload) => {
  return {
    type: portfolioConstants.MY_PORTFOLIO_ACCOUNT_SUMMARY_REQUEST,
    payload,
  };
};

export const accountSummaryComplete = (payload) => {
  return {
    type: portfolioConstants.MY_PORTFOLIO_ACCOUNT_SUMMARY_COMPLETE,
    payload,
  };
};

export const accountSummaryError = (payload) => {
  return {
    type: portfolioConstants.MY_PORTFOLIO_ACCOUNT_SUMMARY_ERROR,
    payload,
  };
};

export const clearPortfolioData = (payload) => {
  return {
    type: portfolioConstants.CLEAR_PORTFOLIO_DATA,
    payload,
  };
};
